import "./App.css";
import ThemeCustomization from "./themes";
import Routes from "./routes";
import { Header } from "./components/header";
import FooterFull from "./components/footer/FooterFull";
import ScrollToTop from "./components/other/ScrollToTop";
import { Box } from "@mui/material";

function App() {
  return (
    <ThemeCustomization>
      <Box
        style={{
          backgroundColor: "#f5f5f5",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
            maxWidth: "1000px",
            margin: "auto",
          }}
        >
          <ScrollToTop />
          <Header />
          <Routes />
          <FooterFull />
        </Box>
      </Box>
    </ThemeCustomization>
  );
}

export default App;
